<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <path d="M15 5l-7 7 7 7" />
  </svg>
</template>

<script>
export default { name: "IconBack" };
</script>
